<template>
  <div>
    <v-dialog v-model="modal_edit" persistent max-width="760px" scrollable>
      <v-card class="dialog-card">
        <!-- Header -->
        <div class="dialog-header">
          <div class="d-flex align-center">
            <div class="dialog-header-icon">
              <v-icon color="white" size="28">
                mdi-clipboard-edit-outline
              </v-icon>
            </div>

            <div class="ml-4">
              <div class="dialog-eyebrow">MANAJEMEN JABATAN</div>

              <div class="dialog-title">Edit Uraian Tugas</div>

              <div class="dialog-subtitle">
                Perbarui informasi dan rincian pelaksanaan tugas.
              </div>
            </div>
          </div>

          <v-btn icon dark class="dialog-close" @click="close_modal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <v-divider></v-divider>

        <!-- FORM -->
        <v-card-text class="dialog-content">
          <v-form ref="form" lazy-validation>
            <!-- URAIAN TUGAS -->
            <div class="dialog-section">
              <div class="dialog-section-heading">
                <div class="dialog-section-icon">
                  <v-icon size="20"> mdi-text-box-outline </v-icon>
                </div>

                <div>
                  <div class="dialog-section-title">Uraian Tugas</div>

                  <div class="dialog-section-description">
                    Tuliskan tugas atau pekerjaan yang dilaksanakan.
                  </div>
                </div>
              </div>

              <div class="dialog-field">
                <label class="dialog-label">
                  Uraian Tugas
                  <span class="dialog-required">*</span>
                </label>

                <v-textarea
                  v-model="form.uraian"
                  placeholder="Masukkan uraian tugas secara lengkap"
                  outlined
                  dense
                  rows="3"
                  auto-grow
                  hide-details="auto"
                  :rules="[rules.required]"
                  class="dialog-input"
                ></v-textarea>
              </div>
            </div>

            <v-divider class="dialog-divider" />

            <!-- BAHAN KERJA -->
            <div class="dialog-section">
              <div class="dialog-section-heading">
                <div class="dialog-section-icon">
                  <v-icon size="20"> mdi-file-document-outline </v-icon>
                </div>

                <div>
                  <div class="dialog-section-title">Bahan Kerja</div>

                  <div class="dialog-section-description">
                    Bahan yang diperlukan untuk melaksanakan tugas.
                  </div>
                </div>
              </div>

              <v-row dense>
                <v-col cols="12" md="6">
                  <div class="dialog-field">
                    <label class="dialog-label">
                      Bahan Kerja
                      <span class="dialog-required">*</span>
                    </label>

                    <v-textarea
                      v-model="form.bahan.kerja"
                      placeholder="Masukkan bahan kerja..."
                      outlined
                      dense
                      rows="3"
                      auto-grow
                      hide-details="auto"
                      :rules="[rules.required]"
                      class="dialog-input"
                    ></v-textarea>
                  </div>
                </v-col>

                <v-col cols="12" md="6">
                  <div class="dialog-field">
                    <label class="dialog-label">
                      Penggunaan
                      <span class="dialog-required">*</span>
                    </label>

                    <v-textarea
                      v-model="form.bahan.penggunaan"
                      placeholder="Jelaskan penggunaan bahan..."
                      outlined
                      dense
                      rows="3"
                      auto-grow
                      hide-details="auto"
                      :rules="[rules.required]"
                      class="dialog-input"
                    ></v-textarea>
                  </div>
                </v-col>
              </v-row>
            </div>

            <v-divider class="dialog-divider" />

            <!-- PERANGKAT KERJA -->
            <div class="dialog-section">
              <div class="dialog-section-heading">
                <div class="dialog-section-icon">
                  <v-icon size="20"> mdi-tools </v-icon>
                </div>

                <div>
                  <div class="dialog-section-title">Perangkat Kerja</div>

                  <div class="dialog-section-description">
                    Perangkat atau alat yang menunjang pelaksanaan tugas.
                  </div>
                </div>
              </div>

              <v-row dense>
                <v-col cols="12" md="6">
                  <div class="dialog-field">
                    <label class="dialog-label">
                      Perangkat Kerja
                      <span class="dialog-required">*</span>
                    </label>

                    <v-textarea
                      v-model="form.perangkat.kerja"
                      placeholder="Masukkan perangkat kerja..."
                      outlined
                      dense
                      rows="3"
                      auto-grow
                      hide-details="auto"
                      :rules="[rules.required]"
                      class="dialog-input"
                    ></v-textarea>
                  </div>
                </v-col>

                <v-col cols="12" md="6">
                  <div class="dialog-field">
                    <label class="dialog-label">
                      Digunakan
                      <span class="dialog-required">*</span>
                    </label>

                    <v-textarea
                      v-model="form.perangkat.digunakan"
                      placeholder="Jelaskan penggunaan perangkat..."
                      outlined
                      dense
                      rows="3"
                      auto-grow
                      hide-details="auto"
                      :rules="[rules.required]"
                      class="dialog-input"
                    ></v-textarea>
                  </div>
                </v-col>
              </v-row>
            </div>

            <v-divider class="dialog-divider" />

            <!-- HASIL KERJA -->
            <div class="dialog-section">
              <div class="dialog-section-heading">
                <div class="dialog-section-icon">
                  <v-icon size="20"> mdi-check-circle-outline </v-icon>
                </div>

                <div>
                  <div class="dialog-section-title">Hasil Kerja</div>

                  <div class="dialog-section-description">
                    Tentukan hasil, satuan, jumlah, dan waktu penyelesaian.
                  </div>
                </div>
              </div>

              <div class="dialog-field">
                <label class="dialog-label">
                  Hasil Kerja
                  <span class="dialog-required">*</span>
                </label>

                <v-textarea
                  v-model="form.hasil.kerja"
                  placeholder="Masukkan hasil kerja..."
                  outlined
                  dense
                  rows="2"
                  auto-grow
                  hide-details="auto"
                  :rules="[rules.required]"
                  class="dialog-input"
                ></v-textarea>
              </div>

              <v-row dense class="mt-1">
                <v-col cols="12" sm="4">
                  <div class="dialog-field">
                    <label class="dialog-label">
                      Satuan
                      <span class="dialog-required">*</span>
                    </label>

                    <v-text-field
                      v-model="form.hasil.satuan"
                      placeholder="Contoh: Dokumen"
                      outlined
                      dense
                      hide-details="auto"
                      :rules="[rules.required]"
                      class="dialog-input"
                    ></v-text-field>
                  </div>
                </v-col>

                <v-col cols="12" sm="4">
                  <div class="dialog-field">
                    <label class="dialog-label">
                      Jumlah
                      <span class="dialog-required">*</span>
                    </label>

                    <v-text-field
                      v-model="form.hasil.jumlah"
                      placeholder="Masukkan jumlah"
                      outlined
                      dense
                      hide-details="auto"
                      :rules="[rules.required]"
                      class="dialog-input"
                    ></v-text-field>
                  </div>
                </v-col>

                <v-col cols="12" sm="4">
                  <div class="dialog-field">
                    <label class="dialog-label">
                      Waktu (Satuan Menit)
                      <span class="dialog-required">*</span>
                    </label>

                    <v-text-field
                      v-model="form.hasil.waktu"
                      placeholder="Contoh: 120"
                      suffix="Menit"
                      outlined
                      dense
                      hide-details="auto"
                      :rules="[rules.required]"
                      class="dialog-input"
                    ></v-text-field>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-form>
        </v-card-text>

        <v-divider />

        <!-- FOOTER -->
        <v-card-actions class="dialog-footer">
          <div class="dialog-footer-note">
            <v-icon size="17" color="grey"> mdi-information-outline </v-icon>

            <span> Pastikan seluruh data sudah benar. </span>
          </div>

          <v-spacer />

          <v-btn
            depressed
            outlined
            color="grey darken-1"
            class="text-none dialog-cancel-btn"
            :disabled="loading"
            @click="close_modal"
          >
            Batal
          </v-btn>

          <v-btn
            depressed
            color="primary"
            class="text-none dialog-submit-btn"
            :loading="loading"
            :disabled="loading"
            @click="edit()"
          >
            <v-icon left size="18"> mdi-content-save-outline </v-icon>

            Simpan Data
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import cookie from "@/helper/cookie.js";
import SData from "@/store/anjab/infojabatan/uraiantugas";

import "@/assets/styles/pages/anjab/infojabatan/uraiantugas/edit.css";

export default {
  name: "ModalEditUraianTugas",

  data: () => ({
    token: "",
    session: "",
    lbtn: false,
    loading: false,

    form: {
      uraian: "",
      bahan: {
        kerja: "",
        penggunaan: "",
      },
      perangkat: {
        kerja: "",
        digunakan: "",
      },
      hasil: {
        kerja: "",
        satuan: "",
        jumlah: "",
        waktu: "",
      },
    },

    rules: {
      required: (value) =>
        (value !== null &&
          value !== undefined &&
          String(value).trim() !== "") ||
        "Field ini wajib diisi",
    },
  }),

  computed: {
    modal_edit: {
      get() {
        return SData.state.modal_edit;
      },

      set(value) {
        SData.commit("open_edit", value);
      },
    },

    item() {
      return SData.state.data;
    },
  },

  watch: {
    async modal_edit(value) {
      if (value) {
        this.token = await cookie.get("token");
        this.setForm();
      }
    },
  },

  methods: {
    setForm() {
      const item = this.item || {};

      this.form = {
        uraian: item.NM_UT || item.uraian || "",

        bahan: {
          kerja: item.NM_BK || (item.bahan && item.bahan.kerja) || "",
          penggunaan:
            item.NM_PDT || (item.bahan && item.bahan.penggunaan) || "",
        },

        perangkat: {
          kerja: item.NM_PK || (item.perangkat && item.perangkat.kerja) || "",
          digunakan:
            item.NM_DUT || (item.perangkat && item.perangkat.digunakan) || "",
        },

        hasil: {
          kerja: item.NM_HK || (item.hasil && item.hasil.kerja) || "",
          satuan: item.NM_SH || (item.hasil && item.hasil.satuan) || "",
          jumlah: item.NM_JH || (item.hasil && item.hasil.jumlah) || "",
          waktu: item.NM_WP || (item.hasil && item.hasil.waktu) || "",
        },
      };

      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }
      });
    },

    async edit() {
      if (!this.$refs.form.validate()) return;

      const item = this.item || {};
      const id = item.ID_INFO || item.id;

      if (!id) {
        SData.commit("alert_text", "ID uraian tugas tidak ditemukan");
        SData.commit("alert_g", true);
        SData.commit("alert_b", false);
        return;
      }

      this.loading = false;

      const data = {
        id: id,
        uraian: this.form.uraian.trim(),

        bahan: {
          kerja: this.form.bahan.kerja.trim(),
          penggunaan: this.form.bahan.penggunaan.trim(),
        },

        perangkat: {
          kerja: this.form.perangkat.kerja.trim(),
          digunakan: this.form.perangkat.digunakan.trim(),
        },

        hasil: {
          kerja: this.form.hasil.kerja.trim(),
          satuan: this.form.hasil.satuan.trim(),
          jumlah: this.form.hasil.jumlah.trim(),
          waktu: this.form.hasil.waktu.trim(),
        },
      };

      const url = `${process.env.VUE_APP_API}/tujab/edit`;

      try {
        const res = await this.axios.put(url, data, {
          headers: {
            Authorization: "Bearer " + this.token,
          },
        });

        if (res.data && res.data.success) {
          SData.commit("refresh", true);
          SData.commit("alert_text", "Berhasil Memperbarui Data");
          SData.commit("alert_b", true);
          SData.commit("alert_g", false);

          this.close_modal();
        } else {
          SData.commit("alert_text", "Gagal Memperbarui Data");
          SData.commit("alert_g", true);
          SData.commit("alert_b", false);
        }
      } catch (error) {
        SData.commit("alert_text", "Gagal Memperbarui Data");
        SData.commit("alert_g", true);
        SData.commit("alert_b", false);

        console.error(
          "Error edit uraian tugas:",
          error.response || error.message,
        );
      } finally {
        this.loading = false;
      }
    },

    close_modal() {
      SData.commit("close_edit", false);
      this.reset();
    },

    reset() {
      this.form = {
        uraian: "",
        bahan: {
          kerja: "",
          penggunaan: "",
        },
        perangkat: {
          kerja: "",
          digunakan: "",
        },
        hasil: {
          kerja: "",
          satuan: "",
          jumlah: "",
          waktu: "",
        },
      };

      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }
      });
    },
  },
};
</script>
